import styled from 'styled-components'

export const CloseButton = styled.button`
  background: none;
  border: none;
  position: absolute;
  top: ${(p) => {
    return p.bigModal ? '20px' : '28px'
  }};
  right: 0;
  padding-right: 32px;
  cursor: pointer;
  z-index: 1002;
`

export const ClosePopUpButton = styled.button`
  background: none;
  border: none;
  position: absolute;
  top: ${(p) => {
    return p.bigModal ? '20px' : '28px'
  }};
  right: 0;
  padding-right: 32px;
  cursor: pointer;
  z-index: 1002;
`

export const CancelButton = styled.div`
  border: none;
  position: absolute;
  top: 21px;
  margin-right: 144px;
  right: 0;
  cursor: pointer;
  z-index: 1002;
`

export const ModalLabelContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 24px 24px 24px 35px;
  border-bottom: ${(p) => {
    return p.bottomBorder ? ' 1px solid rgba(32, 32, 32, 0.1)' : 'none'
  }};
  padding-bottom: ${(p) => {
    return p.paddingBottom ? `${p.paddingBottom}` : 'none'
  }};
  padding-top: ${(p) => {
    return p.paddingTop ? `${p.paddingTop}` : 'none'
  }};
  padding-right: ${(p) => {
    return p.paddingRight ? `${p.paddingRight}` : 'none'
  }};
  justify-content: ${(p) => {
    return p.justifyContent ? `${p.justifyContent}` : 'none'
  }};
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  color: #202020;

  div {
    margin-left: ${(p) => {
    return p.marginLeft ? `${p.marginLeft}` : '8px'
  }};
    cursor: pointer;
  }
`

export const StyledCloseButton = styled.div`
  height: 40px;
  // width: 122px;
  padding: 12px 16px;
  font-family: Inter;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0aa1f4;
  color: #ffffff;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  border-radius: 4px;
`

export const ModalAutoSaveWrapper = styled.div`
  position: absolute;
  z-index: 1001;
  width: 100%;
  display: grid;
  place-items: center;
  top: 25px;
`

